module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-1.f7347e77.png";